export default __webpack_public_path__ + "static/media/logo.c7c56d31.svg";